import { render, staticRenderFns } from "./template-info.vue?vue&type=template&id=93d58e84&scoped=true&"
import script from "./template-info.vue?vue&type=script&lang=ts&"
export * from "./template-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d58e84",
  null
  
)

export default component.exports